import styled from '@emotion/styled';
import AquillaPrimeBottomBanner from 'aquilla/core/molecules/Prime Bottom Banner';
import PropTypes from 'prop-types';
import React from 'react';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { getIsSubscribedToGoal } from '@api/selectors/subscription';
import usePrimeTrialPromoModalStore from '@stores/prime-pitch/store';
import usePrimeQuotaStore from '@stores/prime-quota/store';
import { UserPlatformPlan } from '@stores/prime-quota/types';

const PrimeBottomBannerWrapper = styled.div`
  position: fixed;
  right: max(24px, calc((100vw - 1136px) / 2));
  bottom: 24px;
  left: max(24px, calc((100vw - 1136px) / 2 + 288px));
  z-index: 10;

  display: flex;
  width: auto;
  box-sizing: border-box;
  pointer-events: none;

  & > .aquilla-prime-banner {
    width: 100%;
    pointer-events: auto;
  }

  @media screen and (max-width: 768px) {
    right: 16px;
    bottom: 16px;
    left: 16px;
  }
`;

const PrimeBottomBanner = ({
  title,
  subtitle,
  contextualId,
  goalUID,
  goalSlug,
  analyticsPitchSource = 'Prime Sticky Bottomsheet'
}) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const isPlusUser = useMyInfo(getIsSubscribedToGoal(goalUID));
  const hasPrimePaidPlan =
    usePrimeQuotaStore((state) => state.userPlatformPlan) ===
    UserPlatformPlan.PAID;
  const openPrimeTrialPromoModal = usePrimeTrialPromoModalStore(
    (state) => state.openModal
  );

  if (!isLoggedIn || isPlusUser || hasPrimePaidPlan) {
    return null;
  }

  return (
    <PrimeBottomBannerWrapper>
      <AquillaPrimeBottomBanner
        title={title}
        subtitle={subtitle}
        buttonLabel="Join Prime"
        onButtonClick={() => {
          openPrimeTrialPromoModal(contextualId, goalUID, goalSlug, {
            dismissNavigateTo: null,
            analyticsContext: {
              analyticsPitchSource
            }
          });
        }}
      />
    </PrimeBottomBannerWrapper>
  );
};

PrimeBottomBanner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  contextualId: PropTypes.number.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  analyticsPitchSource: PropTypes.string
};

export default React.memo(PrimeBottomBanner);
